export default __webpack_public_path__ + "static/media/Honored Straps of the Plains.ba4ec000.jpg";